import axios from 'axios'
import assets from './agent/asset'
import auth from './agent/auth'
import payment from './agent/payment'
import config from './agent/config'
import Api from './helpers/Api';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.baseURL = Api.path(window.location);

export default {
    assets,
    auth,
    payment,
    config
};